import React from "react";

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 393 240">
      <g clipPath="url(#clip0)">
        <path
          fill="#FCEEEC"
          d="M196.495 240c108.142 0 195.808-7.693 195.808-17.184s-87.666-17.184-195.808-17.184S.687 213.325.687 222.816 88.353 240 196.495 240"
        ></path>
        <path
          fill="#F6B01A"
          d="M336.264 0H56.727a7.463 7.463 0 0 0-7.463 7.463V175.91a7.463 7.463 0 0 0 7.463 7.463h279.537a7.463 7.463 0 0 0 7.463-7.463V7.463A7.464 7.464 0 0 0 336.264 0"
        ></path>
        <path
          fill="#FFC571"
          d="M335.424 8.993H57.576V174.38h277.848zM242.208 183.373h-91.425v22.893h91.425z"
        ></path>
        <path
          fill="#F6B01A"
          d="M285.97 219.42c-16.717-13.499-50.507-22.726-89.475-22.726s-72.748 9.227-89.475 22.726h178.95"
        ></path>
        <path
          fill="#FFC571"
          d="M107.029 221.752h171.646c2.332 0 4.665.056 6.997 0h.298c3.004 0 3.004-4.664 0-4.664H114.325c-2.333 0-4.665-.056-6.997 0h-.299c-3.004 0-3.004 4.664 0 4.664"
        ></path>
        <path fill="#fff" d="M320.246 20.496H72.754v143.09h247.492z"></path>
        <path fill="#FCEEEC" d="M320.246 20.496H72.754v13.789h247.492z"></path>
        <path
          fill="#D1D1D1"
          d="M84.78 27.707a3.15 3.15 0 0 1-3.154 3.154 3.15 3.15 0 0 1-3.153-3.154 3.15 3.15 0 0 1 3.153-3.153 3.15 3.15 0 0 1 3.153 3.153"
        ></path>
        <path
          fill="#F6B01A"
          d="M95.405 27.707a3.15 3.15 0 0 1-3.153 3.154 3.15 3.15 0 0 1-3.153-3.154 3.15 3.15 0 0 1 3.153-3.153 3.15 3.15 0 0 1 3.153 3.153"
        ></path>
        <path
          fill="#E65546"
          d="M106.031 27.707a3.15 3.15 0 0 1-3.153 3.154 3.15 3.15 0 0 1-3.153-3.154 3.15 3.15 0 0 1 3.153-3.153 3.15 3.15 0 0 1 3.153 3.153"
        ></path>
        <path
          fill="#FCEEEC"
          d="M283.946 94.812c0 8.526-7.333 15.505-16.289 15.505H129.96c-8.956 0-16.289-6.979-16.289-15.505s7.333-15.505 16.289-15.505h137.697c8.956 0 16.289 6.978 16.289 15.505"
        ></path>
        <path
          fill="#212121"
          d="M126.079 100.017h6.381v2.416h-9.394v-14.59h3.004v12.174zM139.439 102.433h-3.004v-14.59h3.004zM156.138 102.433h-3.004l-5.85-9.6v9.6h-3.004v-14.59h3.004l5.859 9.618v-9.618h2.995zM165.383 96.584l-1.568 1.68v4.169h-3.003v-14.59h3.003v6.614l1.325-1.81 3.723-4.804h3.694l-5.178 6.483 5.327 8.107h-3.573zM191.84 96.118h-5.775v3.909h6.773v2.416h-9.777v-14.59h9.758v2.434h-6.754v3.48h5.775zM201.878 92.88l2.734-5.028h3.461l-4.245 7.24 4.357 7.351h-3.499l-2.808-5.113-2.808 5.113h-3.498l4.356-7.352-4.244-7.239h3.461zM214.752 97.293v5.14h-3.004v-14.59h5.691c1.091 0 2.062.196 2.892.597s1.474.97 1.922 1.707q.67 1.106.671 2.519c0 1.427-.485 2.556-1.464 3.377-.98.821-2.333 1.24-4.068 1.24h-2.64zm0-2.435h2.687q1.19 0 1.819-.56c.42-.373.625-.904.625-1.604s-.215-1.297-.634-1.735-.999-.672-1.745-.681h-2.752zM230.238 102.433h-3.004v-14.59h3.004zM240.473 97.097h-2.398v5.346h-3.004v-14.59h5.42c1.726 0 3.051.382 3.993 1.156.943.774 1.4 1.856 1.4 3.256q0 1.497-.644 2.49c-.429.663-1.082 1.195-1.959 1.587l3.153 5.961v.14h-3.228zm-2.388-2.435h2.425c.756 0 1.344-.196 1.754-.578.41-.383.625-.914.625-1.586s-.196-1.232-.588-1.623c-.392-.392-.989-.588-1.8-.588h-2.416zM259 96.118h-5.774v3.909h6.773v2.416h-9.777v-14.59h9.758v2.434h-6.754v3.48H259zM263.823 102.433v-14.59h4.488q1.93 0 3.442.867c1.017.579 1.8 1.4 2.37 2.463.569 1.064.849 2.277.849 3.63v.671c0 1.353-.28 2.566-.84 3.62s-1.344 1.875-2.36 2.453c-1.017.579-2.165.877-3.433.886zm3.004-12.155v9.739h1.456c1.175 0 2.071-.382 2.696-1.157.625-.774.942-1.865.951-3.293v-.774c0-1.483-.308-2.603-.923-3.377-.616-.765-1.512-1.148-2.696-1.148h-1.484z"
        ></path>
        <path
          fill="#fff"
          d="M317.708 64.875c12.526 0 22.679-10.154 22.679-22.68s-10.153-22.678-22.679-22.678-22.679 10.153-22.679 22.679 10.154 22.679 22.679 22.679"
        ></path>
        <path
          fill="#E65546"
          d="m337.545 57.836-4.189 4.188 37.522 37.522 4.189-4.189z"
        ></path>
        <path
          fill="#E65546"
          d="m338.837 55.451-7.876 7.877 10.977 10.977 7.876-7.877z"
        ></path>
        <path
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m346.118 68.285-4.189 4.19 27.072 27.072 4.189-4.19zM336.968 55.445l-7.876 7.877 10.977 10.977 7.876-7.877z"
        ></path>
        <path
          fill="#F4F9FF"
          d="M335.443 59.93c-9.814 9.814-25.786 9.814-35.6 0s-9.814-25.785 0-35.6c9.814-9.814 25.786-9.814 35.6 0s9.814 25.786 0 35.6"
          opacity="0.2"
        ></path>
        <path
          fill="#E65546"
          d="M337.831 62.318c-11.13 11.13-29.247 11.13-40.376 0-11.13-11.13-11.13-29.246 0-40.376 11.129-11.13 29.246-11.13 40.376 0s11.13 29.247 0 40.376m-36.188-36.187c-4.412 4.412-6.614 10.206-6.614 16 0 5.792 2.202 11.586 6.614 15.998 8.826 8.826 23.183 8.826 31.999 0 8.825-8.825 8.825-23.182 0-31.998-8.825-8.826-23.183-8.826-31.999 0"
        ></path>
        <path
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M293.21 38.781c-.411 6.279 1.781 12.697 6.567 17.483 8.825 8.825 23.183 8.825 31.999 0 8.825-8.826 8.825-23.183 0-31.999m4.189 36.188c-11.13 11.13-29.247 11.13-40.377 0-11.129-11.13-11.129-29.247 0-40.377 11.13-11.13 29.247-11.13 40.377 0 11.129 11.13 11.129 29.247 0 40.377"
        ></path>
        <path
          fill="#FFAD36"
          d="m330.162 33.295-3.685-3.685-8.834 8.835-8.835-8.835-3.685 3.685 8.835 8.835-8.835 8.835 3.685 3.685 8.835-8.835 8.834 8.835 3.685-3.685-8.834-8.835z"
        ></path>
        <path
          fill="#fff"
          d="M74.219 179.874c0-7.351 16.774-4.525 22.054-25.44 4.142-16.961-.57-18.659-.57-18.659H45.757s-5.084 1.885-.57 18.659c5.654 20.925 22.055 18.089 22.055 25.44s-15.832 4.525-22.054 25.44c-4.898 16.774.569 18.659.569 18.659h49.948s4.711-1.698.569-18.659c-4.711-18.658-22.054-15.831-22.054-25.44"
        ></path>
        <path
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M74.219 179.874c0-7.351 16.774-4.525 22.054-25.44 4.142-16.961-.57-18.659-.57-18.659H45.757s-5.084 1.885-.57 18.659c5.654 20.925 22.055 18.089 22.055 25.44s-15.832 4.525-22.054 25.44c-4.898 16.774.569 18.659.569 18.659h49.948s4.711-1.698.569-18.659c-4.711-18.658-22.054-15.831-22.054-25.44"
        ></path>
        <path
          fill="#E65546"
          d="M97.401 145.375H43.685c-3.014 0-5.28-2.071-5.28-4.524v-3.769c0-2.454 2.453-4.525 5.28-4.525H97.4c3.014 0 5.281 2.071 5.281 4.525v3.769c0 2.453-2.454 4.524-5.28 4.524"
        ></path>
        <path
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M95.536 143.509H41.819c-3.014 0-5.28-2.071-5.28-4.525v-3.768c0-2.454 2.453-4.525 5.28-4.525h53.717c3.013 0 5.28 2.071 5.28 4.525v3.768c0 2.454-2.454 4.525-5.28 4.525"
        ></path>
        <path
          fill="#F6B01A"
          d="M47.267 215.492c-.57-1.698 1.884-9.991 2.64-11.493 2.65-6.95 10.178-15.402 20.356-15.776 9.805-.373 18.07 8.826 21.298 16.345 2.071 3.582 2.64 11.12 2.64 11.12H47.277v-.186z"
        ></path>
        <path
          fill="#E65546"
          d="M97.401 227.368H43.685c-3.014 0-5.28-2.071-5.28-4.524v-3.769c0-2.454 2.453-4.525 5.28-4.525H97.4c3.014 0 5.281 2.071 5.281 4.525v3.769c0 2.453-2.454 4.524-5.28 4.524"
        ></path>
        <path
          stroke="#212121"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M95.536 225.503H41.819c-3.014 0-5.28-2.071-5.28-4.525v-3.769c0-2.453 2.453-4.524 5.28-4.524h53.717c3.013 0 5.28 2.071 5.28 4.524v3.769c0 2.454-2.454 4.525-5.28 4.525"
        ></path>
        <path
          fill="#E65546"
          d="m308.265 201.015.085-.093c.278-.301.542-.62.827-.912l.913-.732a36 36 0 0 1 3.959-2.994c.246-.164.495-.321.745-.479.249-.157.522-.318.797-.475l.278-.161c7.379-4.224 19.455-7.592 33.259 2.491.145.096.289.181.439.282a33 33 0 0 1 3.616 3.033l.059.052q.525.477.994.938a.91.91 0 0 0 .741.217 1.265 1.265 0 0 0 1.179-1.626 37 37 0 0 1-1.753-2.012h-.013c-.148-.181-.298-.378-.45-.568a48 48 0 0 1-1.826-2.455 20 20 0 0 1-.564-.791 159 159 0 0 1-1.238-1.878 32 32 0 0 1-2.816-5.604 33 33 0 0 1-1.356-4.537 29 29 0 0 1-.506-2.735 10 10 0 0 1-.108-.873c-1.376-13.014 6.807-22.233 9.489-24.861v-.016l.145-.132c.427-.411.68-.628.68-.628.752-.873.647-1.645-.302-2.169a1.76 1.76 0 0 0-1.931.656q-.051.058-.108.109l.108-.181a52 52 0 0 1-2.868 2.619c-.631.506-1.265 1.005-1.898 1.517q-.235.181-.475.35c-.161.114-.329.206-.499.306-21.74 15.494-40.065-4.812-40.065-4.812a11 11 0 0 0-.627-.522c-.752-.6-1.307-.418-1.959.361-.34.371-.37.93-.073 1.336.183.314.42.593.7.824q.214.19.403.403.114.114.253.266c.361.417.712.853 1.106 1.243.329.391.689.828 1.07 1.327q.144.193.293.382l.193.265c5.475 7.274 13.363 22.898-1.887 40.211-.443.503-.86.953-1.265 1.379q-.482.531-.89 1.123a1.103 1.103 0 0 0 .837 1.714h.723a4.04 4.04 0 0 0 1.593-1.166M278.182 151.2l.023-.032c.101-.105.181-.213.286-.315l.318-.253q.644-.558 1.356-1.03l.262-.161c.085-.056.181-.112.273-.164l.092-.056a9.93 9.93 0 0 1 11.44.856l.148.096q.66.476 1.247 1.041l.017.02q.185.164.341.322c.07.062.164.09.257.076a.433.433 0 0 0 .403-.559c-.181-.2-.387-.43-.604-.692l-.154-.193a22 22 0 0 1-.63-.845 5 5 0 0 1-.194-.272c-.032-.049-.381-.568-.426-.648a11 11 0 0 1-.969-1.926q-.285-.766-.466-1.562a13 13 0 0 1-.181-.942c-.017-.101-.024-.2-.033-.302a10.8 10.8 0 0 1 3.254-8.551l.052-.044c.145-.141.233-.216.233-.216.257-.302.221-.568-.105-.745a.59.59 0 0 0-.659.226l-.037.036.037-.065c-.329.325-.66.623-.989.904-.217.18-.439.345-.656.522l-.161.121a2 2 0 0 1-.181.105c-7.478 5.334-13.777-1.649-13.777-1.649l-.213-.18c-.263-.206-.451-.145-.677.124a.36.36 0 0 0-.029.459q.1.164.246.286c.044.04.089.089.132.138l.092.092c.125.144.243.293.378.426.136.134.237.286.362.459.036.044.065.089.105.132l.065.089a10.2 10.2 0 0 1-.653 13.835c-.144.181-.293.325-.43.47a5 5 0 0 0-.314.39.38.38 0 0 0 .289.588h.253c.21-.09.396-.228.542-.403"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M.687 0h391.626v240H.687z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
